import { Box, DialogContent, DialogTitle } from "@mui/material";
import { productBussiness } from "api/bussiness/product/product-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IUpdateApproval } from "mobx-stores/_models/products/approval";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getApprovalFormSchema } from "./schema";

export const UpdateApproval = observer(() => {
  const {
    productManagement: {
      openUpdateApproval,
      setProp,
      productDetail,
      getProductDetail,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
  } = useForm<IUpdateApproval>(getApprovalFormSchema(), {
    businessDate:
      productDetail?.approval?.businessDate || dateTimeToUTCString(dayjs()),
    businessNumber: productDetail?.approval?.businessNumber || "",
    customerRequest: productDetail?.approval?.customerRequest || "",
    businessExpiredDate:
      productDetail?.approval?.businessExpiredDate ||
      dateTimeToUTCString(dayjs()),
    printDate: productDetail?.approval?.printDate || undefined,
    printNumber: productDetail?.approval?.printNumber || "",
    printExpiredDate: productDetail?.approval?.printExpiredDate || undefined,
  });
  const saveHandler = useCallback(
    async (data: IUpdateApproval) => {
      if (!productDetail || !productDetail?.id) return;
      await productBussiness.updateApproval(productDetail?.id, data);
      await getProductDetail(productDetail?.id);
      setProp("openUpdateApproval", false);
    },
    [getProductDetail, productDetail, setProp]
  );

  return (
    <DialogForm
      open={openUpdateApproval}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openUpdateApproval", false)}
      onCancelBtnClicked={() => setProp("openUpdateApproval", false)}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>
        {`Cập nhật ký duyệt: `}
        <span style={{ color: "blue" }}>{`${productDetail?.name}${
          productDetail?.customer?.dealingName
            ? `- ${productDetail?.customer?.dealingName}`
            : ""
        }`}</span>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
